import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlassCard, SectionLabel, GhostButton } from "@/components/primitives";
import { Bell, CheckCircle2, Search } from "lucide-react";

const PRIO = { critical: "text-red-400 border-red-500/30 bg-red-500/10", high: "text-orange-400 border-orange-500/30 bg-orange-500/10", medium: "text-blue-400 border-blue-500/30 bg-blue-500/10", low: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10" };

export default function Notifications() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const load = async () => { const { data } = await api.get("/notifications"); setList(data); };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  const filtered = list.filter((n) => (filter === "all" || (filter === "unread" ? !n.read : n.read)) && (!q || n.title.toLowerCase().includes(q.toLowerCase()) || n.body.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="space-y-5" data-testid="notifications-page">
      <div className="flex flex-wrap justify-between items-end gap-3">
        <div><SectionLabel>Notifications</SectionLabel><h1 className="mt-1 text-3xl font-bold tracking-tight">Notification <span className="gradient-text">center</span></h1></div>
        <GhostButton onClick={markAll} data-testid="notifs-mark-all"><CheckCircle2 className="h-4 w-4" /> Mark all read</GhostButton>
      </div>

      <GlassCard className="p-3 flex flex-wrap gap-2 items-center">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-500" />
          <input data-testid="notifs-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search notifications" className="w-full pl-9 pr-3 py-2 bg-white/[0.04] border border-white/10 rounded-xl text-sm focus:outline-none focus:border-cyan-400/50" />
        </div>
        {["all","unread","read"].map((f) => (
          <button key={f} data-testid={`notifs-filter-${f}`} onClick={() => setFilter(f)} className={`text-xs uppercase font-mono tracking-wider px-3 py-2 rounded-lg border ${filter === f ? "bg-cyan-500/10 border-cyan-500/30 text-cyan-200" : "bg-white/[0.03] border-white/10"}`}>{f}</button>
        ))}
      </GlassCard>

      <div className="space-y-2">
        {filtered.map((n) => (
          <GlassCard key={n.id} className={`p-4 ${n.read ? "opacity-60" : ""}`}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-start gap-3 min-w-0">
                <Bell className="h-4 w-4 mt-0.5 text-cyan-300" />
                <div className="min-w-0">
                  <div className="text-sm font-semibold truncate">{n.title}</div>
                  <div className="text-xs text-slate-400 truncate">{n.body}</div>
                  <div className="text-[10px] mt-1 font-mono uppercase tracking-wider text-slate-500">{n.category}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded border ${PRIO[n.priority] || PRIO.medium}`}>{n.priority}</span>
                {!n.read && <button data-testid={`notif-read-${n.id}`} onClick={() => markOne(n.id)} className="text-[10px] font-mono px-2 py-1 rounded bg-white/5 hover:bg-white/10">Mark read</button>}
              </div>
            </div>
          </GlassCard>
        ))}
        {filtered.length === 0 && <div className="text-slate-400 text-sm p-6 text-center">No notifications.</div>}
      </div>
    </div>
  );
}
